import React from 'react';
import { Tooltip, Tag } from 'antd';

export default function getHerbsForRecepy(record) {

    if(record === undefined) {
        return null
    }

    const newList = [];
    record.herbs.forEach(_ => {
      const found = newList.find(__ => __.item.id === _.item.id)
      if(found === undefined) {
        _.amount = 1;
        newList.push(_)
      }
      else {
        found.amount++;
      }
    })
      
    return newList.map(_ => <Tooltip key={_.id} title={`Item id ${_.item.id}`}>
            <Tag color={'green'} key={_.id}>{_.amount > 1 ? `${_.amount} x ${_.item.name}` : `${_.item.name}`}</Tag>
        </Tooltip>)
}

export function GetHerbsForRecepyCsv(record) {
    if(record === undefined) {
        return null
    }

    const newList = [];
    record.herbs.forEach(_ => {
      const found = newList.find(__ => __.item.id === _.item.id)
      if(found === undefined) {
        _.amount = 1;
        newList.push(_)
      }
      else {
        found.amount++;
      }
    })

    let text = undefined;

    newList.forEach(_ => {
      if(text === undefined) {
        text = _.amount > 1 ? `${_.amount}x ${_.item.name}` : `${_.item.name}`
      }
      else {
        text = text.concat(_.amount > 1 ? ` and ${_.amount}x ${_.item.name}` : ` and ${_.item.name}`)
      }
      
    })
      
    return text
}